module.exports = __webpack_public_path__ + "files/89fdc20698898980d1c18f1d8919a9f8.png";